"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { HttpTypes } from "@medusajs/types";
import { sdk } from "@/lib/medusa/client";
type CustomerContextType = {
  customer: HttpTypes.StoreCustomer | undefined | null;
  setCustomer: React.Dispatch<React.SetStateAction<HttpTypes.StoreCustomer | undefined | null>>;
  refreshCustomer: () => Promise<void>;
};

const CustomerContext = createContext<CustomerContextType | null>(null);

type CustomerProviderProps = {
  children: React.ReactNode;
};

export const CustomerProvider = ({ children }: CustomerProviderProps) => {
  const [customer, setCustomer] = useState<HttpTypes.StoreCustomer | null>();

  useEffect(() => {
    if (customer) {
      return;
    }

    sdk.store.customer
      .retrieve()
      .then(({ customer }) => {
        setCustomer(customer);
      })
      .catch((err) => {
        console.info("Error retrieving customer:", err);
        setCustomer(null);
      });
  }, [customer]);

  const refreshCustomer = async () => {
    const { customer } = await sdk.store.customer.retrieve();
    setCustomer(customer);
  };

  return (
    <CustomerContext.Provider
      value={{
        customer,
        setCustomer,
        refreshCustomer,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  const context = useContext(CustomerContext);

  if (!context) {
    throw new Error("useCustomer must be used within a CustomerProvider");
  }

  return context;
};
